var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__type--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 2H3a1 1 0 00-1 1v3a1 1 0 002 0V4h7v16H9.3a1 1 0 000 2h5.4a1 1 0 100-2H13V4h7v2a1 1 0 002 0V3a1 1 0 00-1-1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }